<template>
  <div class="student-rank">
    <studentRankTopBar @back="back" @chartDialogShow="chartDialogClick" @selectCourseChange="selectCourseChange"
      @derivedScore="derivedScore" :examType="examType" :studentList="studentList" :courseList="courseList" />
    <div class="table">
      <studentRankTable @editStudentScore="editStudentScore" @studentSelect="studentSelect" :examType="examType"
        :studentList="studentList" :examInfo="examInfo" :courseList="courseList" :courseFullList="courseFullList" />
    </div>
    <!-- 分页容器 -->
    <div class="pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
    </div>
    <barChartDialog :chartDialogShow.sync="chartDialogShow" :studentAvgScoreRankList="studentAvgScoreRankList"
      :courseFullList="courseFullList" v-show="chartDialogShow" />
    <scoreEditDialog :scoreInfo="scoreInfo" :scoreEditShow.sync="scoreEditShow" v-show="scoreEditShow"
      @scoreEditSubmit="scoreEditSubmit" />
  </div>
</template>

<script>
import studentRankTopBar from "./components/student-rank-topBar/studentRankTopBar.vue";
import studentRankTable from "./components/student-rank-table/studentRankTable.vue";
import barChartDialog from "./components/bar-chart-dialog/barChartDialog.vue";
import scoreEditDialog from "./components/score-edit-dialog/scoreEditDialog.vue";
import pagination from "@/components/pagination/pagination";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  components: {
    studentRankTopBar,
    studentRankTable,
    barChartDialog,
    pagination,
    scoreEditDialog
  },
  data() {
    return {
      total: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      examType: "",
      classId: "",
      gradeId: "",
      examInfoId: "",
      examInfo: {},
      studentSelectList: [],
      studentList: [], // 学生排行列表
      studentAvgScoreRankList: [], // 学生单次考试学生成绩
      chartDialogShow: false,
      courseList: [],
      courseFullList: [], // 分制列表
      courseIds: [], // 选择指定的科目进行成绩排名的科目列表
      scoreEditShow: false, // 学生成绩修改弹窗
      scoreInfo: {}, // 学生成绩修改信息
      gradeExamSearchData: null, // 年级考试搜索条件
    };
  },
  created() {
    // console.log("options:", this.$route.query);
    this.examType = this.$route.query.examType;
    this.examInfo = JSON.parse(this.$route.query.examInfo);
    this.courseFullList = this.$route.query.courseFullList;
    if (this.examType == 'grade' && this.$route.query.searchData) {
      // 年级考试搜索条件
      this.gradeExamSearchData = JSON.parse(this.$route.query.searchData);
    };
    this.getStudentRanking();
  },
  methods: {
    // 返回
    back() {
      if (this.examType == 'grade') {
        this.$router.push({
          path: "/achievement-analysis-grade",
          query: {
            searchData: JSON.stringify(this.gradeExamSearchData)
          },
        });
        return;
      };
      this.$router.back();
    },
    // 修改学生成绩点击提交
    scoreEditSubmit(row) {
      let data = [];
      row.courseInfoList.map(item => {
        data.push({
          "examInfoId": this.examInfo.id,
          "studentId": row.studentId,
          "courseId": item.courseId,
          "score": item.score
        })
      })
      this.put(this.$url.updateScoreByStudent, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.scoreEditShow = false;
        this.getStudentRanking();
      })
    },
    // 修改学生成绩
    editStudentScore(row) {
      // console.log("row:", row);
      this.scoreEditShow = true;
      this.scoreInfo = row;
    },
    // 点击导出
    derivedScore() {
      if(!this.studentList || !this.studentList.length) return this.$message.warning("暂无成绩");
      let courseList = this.courseList.map((item) => item.courseId);
      // console.log(courseList);

      let action = `${baseURL}${this.$url.studentRankingExcelPC}?examInfoId=${this.examInfo.id
        }&gradeId=${this.examInfo.gradeId}&classId=${this.examInfo.classId || ""
        }&courseIds=${this.courseIds.length ? this.courseIds : courseList}`;
      window.open(action);

      // this.get(
      //   `${this.$url.studentRankingExcelPC}?examInfoId=${
      //     this.examInfo.id
      //   }&gradeId=${this.examInfo.gradeId}&classId=${
      //     this.examInfo.classId || ""
      //   }&courseIds=${this.courseIds.length ? this.courseIds : courseList}`
      // ).then((res) => {
      //   console.log("导出返回==>", res);
      //   window.location.href = baseURL + "/common/download?fileName=" + encodeURI(res.data) + "&delete=" + true;
      // });
    },
    // 选择指定的科目进行成绩排名
    selectCourseChange(e) {
      this.courseIds = e;
      this.getStudentRanking();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getStudentRanking();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getStudentRanking();
    },
    // 获取学生排行
    getStudentRanking() {
      let data = {
        examInfoId: this.examInfo.id,
        gradeId: this.examInfo.gradeId,
        classId: this.examInfo.classId || "",
        studentName: "",
        studentNumber: "",
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
      };
      if (this.courseIds.length) {
        data.courseIds = this.courseIds;
      } else {
        delete data.courseIds;
      }
      this.post(this.$url.getStudentRanking, data).then((res) => {
        // console.log("获取学生排行：", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取学生排行失败");
        this.total = res.total;
        if (res.rows && res.total > 0) {
          res.rows.forEach((item) => {
            item.courseInfoList.forEach((aItem) => {
              if (
                !this.courseList.some(
                  (item) => item.courseName === aItem.courseName
                )
              ) {
                this.courseList.push({
                  courseName: aItem.courseName,
                  courseId: aItem.courseId,
                });
              }
            });
          });
        }

        this.studentList = res.rows;
      });
    },
    onceStudentAvgScoreRankContrast() {
      let data = {
        examInfoId: this.examInfo.id,
        studentIds: this.studentSelectList,
      };
      // console.log("data", data);
      this.post(this.$url.onceStudentAvgScoreRankContrast, data).then((res) => {
        if (res.code !== 200) return;
        // console.log("学生平均分排名对比：", res);
        this.chartDialogShow = true;
        this.studentAvgScoreRankList = res.data;
      });
    },
    chartDialogClick(e) {
      if (!this.studentSelectList.length)
        return this.$message.warning("请选择学生");
      if (this.studentSelectList.length < 2)
        return this.$message.warning("至少选择两个学生");
      this.onceStudentAvgScoreRankContrast();
    },
    studentSelect(e) {
      this.studentSelectList = e;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementStudentRank.scss";
</style>